import { useSyncExternalStore } from "react";
import {
    subscribeSavedSearchUnread,
    getSavedSearchUnread,
} from "./savedSearchUnreadStore";

/**
 * Returns the live unread-matches counter for the saved-search header pill.
 * `null` while not yet loaded, integer (0+) afterwards.
 */
export default function useSavedSearchUnread() {
    return useSyncExternalStore(subscribeSavedSearchUnread, getSavedSearchUnread, getSavedSearchUnread);
}
